import BaseOptionsBundle from "%/dynamic-components/render-engine/classes/base-options";
import BorderRadius from "%/dynamic-components/render-engine/options/border-options/border-radius";
import Visible from "%/dynamic-components/render-engine/options/visible";
import Opacity from "%/dynamic-components/render-engine/options/opacity";
import Rotate from "%/dynamic-components/render-engine/options/layout-options/rotate";
import { inspectorTools } from "%/dynamic-components/builder-engine/inspector/inspector-tool-map";
import Blur from "%/dynamic-components/render-engine/options/layout-options/blur";
import ZIndex from "%/dynamic-components/render-engine/options/layout-options/zindex";

export default class AppearanceOptions extends BaseOptionsBundle {

  optionTitle = "Appearance";
  static optionClassName = "i-dynamic-appearance";
  inspectorToolGroup = "appearance";
  useInspectorLabel = false;
  static userInterfaceComponent = {
    component: inspectorTools.APPEARANCE_TOOL_SET,
  };

  constructor(values = {}, hideFromInspector = {}, isOverridable = undefined) {
    super(values, [
      new Visible(undefined, hideFromInspector["visible"] ?? false),
      new Opacity(undefined, hideFromInspector["opacity"] ?? false),
      new Rotate(undefined, hideFromInspector["rotate"] ?? false),
      new Blur(undefined, hideFromInspector["blur"] ?? false),
      new BorderRadius(undefined, hideFromInspector["border-radius"] ?? true),
      new ZIndex(undefined, hideFromInspector["z-index"] ?? false),
    ]);

    this.isOverridable = isOverridable !== false;
  }
}
